export enum Language {
    eng = 'eng',
    spa = 'spa',
}
